import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  root: {
    width: 24,
    height: 24,
    display: 'inline-block',

    filter: 'invert(1)'
  }
}))
